import { render, staticRenderFns } from "./MaterialInspectLayout.vue?vue&type=template&id=703ac666&scoped=true&"
import script from "./MaterialInspectLayout.vue?vue&type=script&lang=js&"
export * from "./MaterialInspectLayout.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "703ac666",
  null
  
)

export default component.exports